import {
	BoundActions,
	createActionsHook,
	createHook,
	createStateHook,
	HookActionsFunction,
	HookFunction,
	HookStateFunction,
	StoreActionApi,
} from 'react-sweet-state';

import { UserResponse } from '@townsquare/identity-client';

import { userStore } from './store';
import { User } from './types';

export const useUserStore: HookFunction<
	User,
	BoundActions<
		User,
		{
			initUser: (user: UserResponse) => ({ setState }: StoreActionApi<User>) => Promise<{
				name: string;
				accountId: string;
				email: string | undefined;
				locale: string | undefined;
				picture: string;
				timeZone: string | undefined;
				jobTitle: string | undefined;
			}>;
			initCurrentUser: () => ({ setState }: StoreActionApi<User>) => Promise<User>;
			setUserLocale: (locale: any) => ({ setState }: StoreActionApi<User>) => Promise<void>;
		}
	>,
	void
> = createHook(userStore);
export const useCurrentUser: HookStateFunction<User, void> = createStateHook(userStore);
export const useAccountId: HookStateFunction<string, void> = createStateHook(userStore, {
	selector: (state) => state.accountId,
});
export const useCurrentUserAvatarUrl: HookStateFunction<string | undefined, void> = createStateHook(
	userStore,
	{
		selector: (state) => state.picture,
	},
);
export const useUserActions: HookActionsFunction<
	BoundActions<
		User,
		{
			initUser: (user: UserResponse) => ({ setState }: StoreActionApi<User>) => Promise<{
				name: string;
				accountId: string;
				email: string | undefined;
				locale: string | undefined;
				picture: string;
				timeZone: string | undefined;
				jobTitle: string | undefined;
			}>;
			initCurrentUser: () => ({ setState }: StoreActionApi<User>) => Promise<User>;
			setUserLocale: (locale: any) => ({ setState }: StoreActionApi<User>) => Promise<void>;
		}
	>
> = createActionsHook(userStore);
